// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"TemplateNone_conteiner__28DIy","information":"TemplateNone_information__3noNp"};